import { useNavigate } from 'react-router';

interface NoAdvanceInfoProps {}

const NoAdvanceInfo = ({}: NoAdvanceInfoProps) => {
  const personId = sessionStorage.getItem('personId') ?? '';

  const navigate = useNavigate();

  // const [isSendModalOpen, setIsSendModalOpen] = useState(false);

  // const onSend = () => {
  //   setIsSendModalOpen(true);
  // };

  const onInput = () => {
    navigate(`/dashboard/customer/${personId}/info`);
  };

  return (
    <div className="w-full">
      <div className="flex flex-col gap-8">
        <div className="w-full text-center text-[#bcb8c3] text-lg font-medium font-['Pretendard Variable'] leading-snug">
          아직 작성된 사전정보가 없어요!
        </div>
        <div className="w-full text-center text-[#746f7e] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
          회원에게 설문지 작성 알림톡을 보내거나
          <br />
          정보를 직접 입력하실 수 있어요.
        </div>
      </div>
      <div className="w-full h-20"></div>
      <div className="flex w-full gap-12">
        {/* <Button onClick={onSend} text="발송하기" /> */}
        <Button onClick={onInput} text="기입하기" />
      </div>
    </div>
  );
};

interface ButtonProps {
  text: string;
  onClick: () => void;
}
const Button = ({ text, onClick }: ButtonProps) => {
  return (
    <div
      onClick={onClick}
      className="w-full h-[45px] px-10 py-3 bg-[#7750e9] rounded-lg justify-center items-center gap-2.5 inline-flex"
    >
      <div className="text-[#ebe9f4] text-base font-medium font-['Pretendard Variable'] leading-[21px]">
        {text}
      </div>
    </div>
  );
};

export default NoAdvanceInfo;
